import { Component, OnInit } from '@angular/core';
// using reactive forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { PaymentService } from '../../../payment/payment.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public reconnectForm:FormGroup;
  public submitted = false;
  public showPasswordOnPress: boolean;
  public showPassword: boolean;
  public reconnecte=false;
  public closeResult: string;
  public subscribed:String;
 public existProfile=false;
  constructor(private formBuilder: FormBuilder,private paymentservice:PaymentService, private router: Router, private authService: AuthService,private modalService: NgbModal) {
  }
  errtext = '';
  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ["",[ Validators.required,Validators.email]],
      password: [
        "", Validators.required


      ]
    }),
    this.reconnectForm=this.formBuilder.group({
      email:[ "",[Validators.required,Validators.email]]
    });


  }



  get formControl() {
    return this.loginForm.controls;
  }
  get email() {
    return this.loginForm.get("email")
  }
  get email2(){
    return this.reconnectForm.get('email')
  }
  get password() {
    return this.loginForm.get("password")
  }
  onLogin(): void {
    if (this.loginForm.valid) {
      console.log(this.loginForm.value, 'this.loginForm.value');
  
      this.authService.login(this.loginForm.value)
        .subscribe(
          data => {
            console.log(data.status, 'response login service');
            console.log(data, 'response login service');
            localStorage.setItem('token', data['body']['accessToken'].toString());
            localStorage.setItem('Role', data['body']['rl'].toString());
            localStorage.setItem('email', data['body']['email'].toString());
  const rolee=data['body']['rl'];
  const subscribed = data['body']['subscribed'];
  const hasProfile = data['body']['hasprofile'];
            if (rolee == "Client") {
              if (subscribed) {
  
                  this.router.navigate(['/Dashboard']);
    
              } else {
                this.router.navigate(['/Subscription']);
              }
            } else {
              this.router.navigate(['/clients']);
            }
          },
          error => {
            console.log(error, 'error');
            if (error.status == 404) {
              this.errtext = 'utilisateur inexistant!';
              console.log('not found');
              this.reconnecte = false;
            } else if (error.status == 401) {
              this.errtext = error.error.message;
              console.log('pwd incorrect');
              this.reconnecte = false;
            }
          }
        );
    }
  }
  
reconnect(content):void{

//27/12/2022
this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
  } else {
     return  `with: ${reason}`;
  }
}
/*
reconnectok():void{

     
  if(this.reconnectForm.valid){
    console.log(this.reconnectForm.value)
    this.authService.EmailsList(this.reconnectForm.get('email').value).subscribe(data=>{
       if(data.body[0]['User']!='Not Found'){ 
          this.authService.reconnect(this.reconnectForm.get('email').value).subscribe(
            data =>{
      
               localStorage.setItem('token', '')
               this.reconnecte=true
               this.errtext="félicitations! Vous pouvez vous connecter maintenant"
               this.email.reset()
               this.password.reset()
               this.router.navigate(['/']);
            },
            error => {
              console.log(error, 'error')
              if (error.status == 404) {
                 
              }
              else if (error.status == 401) {
                
              }
      
            }
          );
        }
        else{
            this.errtext = 'Adresse courriel invalide ou inexistante'
        }
    });
  }
}
  */

//26/12/2022

ForgetPassword():void{
  
  this.router.navigate(['/ForgetPassword']);
}
}

